import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContex";
import { format } from "timeago.js";
import * as timeago from "timeago.js";

import pt_BR from "timeago.js/lib/lang/pt_BR";

export default function Message({ message, own, amigoId }) {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  const [amigo, setAmigo] = useState("");

  const { user } = useContext(AuthContext);
  timeago.register("pt_BR", pt_BR);

  useEffect(() => {
    const getSender = async () => {
      if (amigoId !== user._Id) {
        try {
          const res = await axios.get(`usuarios?userId=` + amigoId);
          setAmigo(res.data.username);
        } catch (err) {
          return "error";
        }
      }
    };
    getSender();
  }, [amigo]);

  return (
    <>
      <li className={own ? "clearfix odd" : "clearfix"}>
        <div className="chat-avatar">
          <img
            src={PS + "users/noavatar.jpg"}
            className="rounded"
            alt="dominic"
          />
        </div>
        <div className="conversation-text">
          <div className="ctext-wrap">
            <i>{own ? user.username : amigo}</i>
            <p>{message.text}</p>
            <small
              style={{ color: "black", fontStyle: "italic", fontSize: "10px" }}
            >
              {format(message.createdAt, "pt_BR")}{" "}
            </small>
          </div>
        </div>

        <div className="conversation-actions dropdown">
          <button
            className="btn btn-sm btn-link"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="uil uil-ellipsis-v"></i>
          </button>

          <div className="dropdown-menu">
            <a className="dropdown-item" href="#">
              Copy Message
            </a>
            <a className="dropdown-item" href="#">
              Edit
            </a>
            <a className="dropdown-item" href="#">
              Delete
            </a>
          </div>
        </div>
      </li>
    </>
  );
}
